import { formatNumber } from '../../../utils/functions';

const between = (min, max, value) =>
    value?.trim().length >= min && value.length <= max;

const minValue = (min, number) => number !== '' && number >= min;
const normalizeNumericValue = (value) => {
    if (value === null || value === undefined || value === '') return 0;
    if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

    const normalized = String(value).replace(/[^0-9.-]/g, '');
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
};
const getStartOfDay = (value) => {
    const date = new Date(value);
    date.setHours(0, 0, 0, 0);
    return date.getTime();
};
const getStartOfToday = () => getStartOfDay(new Date());

export const basicsValidators = (
    campaign,
    budgets = null,
    totalSpent = 0,
    originalStartPeriod = null
) => ({
    name: () => {
        if (!between(3, 255, campaign.name)) {
            return 'name';
        }
        return null;
    },

    brand: () => {
        if (!between(3, 255, campaign.brand)) {
            return 'brand';
        }
        return null;
    },

    budget: () => {
        const budgetValue = normalizeNumericValue(campaign?.budget?.budget);
        const spentValue = normalizeNumericValue(totalSpent);

        if (!minValue(1, budgetValue)) {
            return 'budget';
        }

        if (budgets && budgets[campaign.selectedCurrency.short_name] < 0) {
            return 'budgetInsufficient';
        }

        console.log('budgetValue:', budgetValue, 'spentValue:', spentValue);

        if (spentValue > 0 && budgetValue < spentValue) {
            const currencySymbol = campaign?.selectedCurrency?.symbol || '';
            const minBudget = `${currencySymbol}${formatNumber(
                spentValue,
                'currency'
            )}`;
            return {
                code: 'budgetBelowSpent',
                values: {
                    min: minBudget,
                },
            };
        }

        return null;
    },

    selectedCreativeCategories: () => {
        if (
            !campaign.selectedCreativeCategories ||
            campaign.selectedCreativeCategories.length === 0
        ) {
            return 'selectedCreativeCategories';
        }

        return null;
    },

    cpm: () => {
        if (
            !campaign.budget.cpmOptimizer &&
            !minValue(1, campaign.budget.cpm)
        ) {
            return 'cpm';
        }
        return null;
    },

    // TIMING
    periodValue: () => {
        if (!campaign.timing.periodValue) {
            return 'timingPeriod';
        }

        const [startPeriod, endPeriod] = campaign.timing.periodValue;
        const today = getStartOfToday();
        const start = getStartOfDay(startPeriod);
        const end = new Date(endPeriod).getTime();
        const hasSpent = normalizeNumericValue(totalSpent) > 0;
        const originalStart = getStartOfDay(originalStartPeriod);

        if (
            end < start ||
            end < today ||
            (!hasSpent && start < today) ||
            (hasSpent && Number.isFinite(originalStart) && start !== originalStart)
        ) {
            return 'timingPeriodPast';
        }

        return null;
    },

    selectedTimezone: () => {
        if (campaign.timing.selectedTimezone === '') {
            return 'timingTimezone';
        }
        return null;
    },

    dayParting: () => {
        if (
            campaign.timing.isDayParting &&
            campaign.timing.hoursEnabled === '0'.repeat(168)
        ) {
            return 'timingDayParting';
        }
        return null;
    },
});
